// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"2f3817f3","787":"bd54e3f8"}[chunkId] + ".chunk.js";
};